"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EWizardType = void 0;
let EWizardType = exports.EWizardType = /*#__PURE__*/function (EWizardType) {
  EWizardType["Autoship"] = "Autoship";
  EWizardType["Subscription"] = "Subscription";
  return EWizardType;
}({});
